import ApplicationController from './application_controller'

// Opens a lot's transport widget in an embedded modal (iframe), the same flow
// partners get on their own sites. The Stripe payment still redirects out.
export default class extends ApplicationController {
  static targets = ['dialog', 'frame']

  // A positive lot value replaces the lot prices imported with the catalogue:
  // the widget prices the transport and the insurance on it (the URL carries
  // the public_catalog source). Anything else is left out.
  open ({ params }) {
    const url = new URL(params.url, window.location.origin)
    const value = document.getElementById(params.valueInput).valueAsNumber
    if (value > 0) url.searchParams.set('value', value)

    this.frameTarget.src = url
    this.dialogTarget.showModal()
  }

  close () {
    this.dialogTarget.close()
    this.frameTarget.src = 'about:blank'
  }
}
